import { RIGHTS } from 'core-uda/Rights'
import { hasYamlRight } from './deprecatedLayers.utils'

export function deprecatedSouthPoleCCAMLRLayer() {
  if (hasYamlRight('southPoleCCAMLR')) return {}

  const southPoleCCAMLRUrl = RIGHTS('map.layers.southPoleCCAMLR.url', '')

  if (!southPoleCCAMLRUrl) return {}

  let type = 'tileWMS',
    url = ''

  const arr = southPoleCCAMLRUrl.split(' ')
  if (arr[0]) {
    type = arr[0]
  }
  if (arr.length > 1 && arr[1]) {
    url = arr[1]
  }

  const centerZoomFactor = RIGHTS('map.layers.zoomFactor', 1)

  return {
    type,
    url,
    data: { icon: 'southPole' },
    params: {
      TRANSPARENT: true,
      LAYERS:
        'gis:hillshade_and_bathymetry,gis:coastline_sub,gis:statistical_areas,gis:subareas',
    },
    //crossOrigin: null,
    projection: 'EPSG:102020',
    maxZoom: 18 * centerZoomFactor,
    zoomFactor: centerZoomFactor === 1 ? 2 : 1.5,
  }
}
